/**
 * Netflix Picture in Picture now for Prime & D+ [QVI]
 *
 * Exposes a single static resource — `times-solid.svg` — scoped to a list of streaming
 * origins (netflix.com, primevideo.com, disneyplus.com, hulu.com, hbomax.com, …). So it
 * is detectable, but only from one of those sites. One CORS-free image load confirms it.
 *
 * Manifest verified against version 0.2.92.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jkmakgpojigahjdalffbkimpnpabelio';

export const netflixPip: ExtensionDefinition = {
  id: ID,
  name: 'Netflix Picture in Picture now for Prime & D+ [QVI]',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  requiredOrigin: 'https://www.netflix.com',
  notes:
    'Single static WAR (times-solid.svg) scoped to streaming-service origins, so only ' +
    'those sites can detect it. Loads as an image without a CORS grant.',
  signals: [
    {
      id: 'war-times-solid-svg',
      kind: 'web-accessible-resource',
      description:
        'Load times-solid.svg via <img> — the PiP control icon, exposed only to the ' +
        'streaming origins the extension supports.',
      weight: 1,
      run: () => probeImage(ID, 'times-solid.svg'),
    },
  ],
};
